import React, { useEffect, useState } from "react";
import { Col, Form, Input, Row, Select } from "antd";
import {
  GetLoggedInUser,
  encryptedData,
  onlyMobileInput,
  isSuperAdmin,
  GetLoggedInOrganization,
  rolesForOrganization,
} from "../../../utils";
import { fetchOrganizations } from "../../../redux/Services/OrganizationServices";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { UserServices } from "../../../redux/Services";
import HeadingBack from "../../../component/HeadingBack";
import { usePermission } from "../../../hooks/usePermission";
import { UserId } from "../../../utils/";
import API_BASEURL from "../../../api/url";
import LoadingButton from "../../../component/LoadingButton";
import { useAsyncAction } from "../../../hooks/useAsyncAction";

import {
  PasswordRule,
  ValidateEmail,
  ValidatePhone,
  onlyAlphaNumericFilter,
  onlyTextandSpaceFilter,
} from "../../../utils/validation";
import { toast } from "react-toastify";
import axios from "axios";

const { Option } = Select;

const AddUser = () => {
  console.log("first", API_BASEURL);
  const permission = usePermission("Users Management", "Add");
  onlyMobileInput();
  let LOG_IN_USER = GetLoggedInUser();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const roleList = useSelector((state) => state.user.roleList || []);
  const { mutate: fetchRoles } = useMutation((data) =>
    // ForAssignment: every role that can be given to a user (incl. organization roles)
    dispatch(UserServices.fetchRolesApi(data, { ...user, ForAssignment: 1 }))
  );
  const { mutateAsync: addUser } = useMutation((data) =>
    dispatch(UserServices.addUsersApi(data, navigate))
  );
  const user = { UserId: UserId };

  const [otp, setOtp] = useState(["", "", "", ""]);
  const [email, setEmail] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [timer, setTimer] = useState(0);
  const superAdmin = isSuperAdmin();
  const [organizations, setOrganizations] = useState([]);
  const selectedOrganizationId = Form.useWatch("OrganizationId", form);

  useEffect(() => {
    fetchRoles({});
    // Super admin can create users for any active organization
    if (superAdmin) {
      fetchOrganizations({ Status: 1 }).then(setOrganizations);
      form.setFieldsValue({ OrganizationId: GetLoggedInOrganization().OrganizationId });
    }
  }, []);

  // New users default to the organization's "Admin" role (created with the organization)
  useEffect(() => {
    const orgId = superAdmin ? selectedOrganizationId : GetLoggedInOrganization().OrganizationId;
    const roles = rolesForOrganization(roleList, orgId);
    const admin =
      roles.find((r) => r.OrganizationId === orgId && r.Role?.toLowerCase() === "admin") ||
      roles.find((r) => r.Role?.toLowerCase() === "admin");
    form.setFieldsValue({ RoleId: admin ? admin.RoleId : "" });
  }, [selectedOrganizationId, roleList]);
  const startTimer = () => {
    setTimer(60);
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  const [handleSubmit, submitting] = useAsyncAction((values) => {
    // if (!isOtpVerified) {
    //   toast.error("Please verify OTP before submitting");
    //   return;
    // }
    let _data = { ...values };
    _data.UserId = LOG_IN_USER?.UserId;
    _data.Password = encryptedData(_data?.Password);
    return addUser(_data);
  });

  const handleSendOtp = async () => {
    try {
      const emailValue = form.getFieldValue("Email");
      if (!emailValue) {
        toast.error("Please enter email first");
        return;
      }
      setEmail(emailValue);

      const res = await axios.post(`${API_BASEURL.API_BASEURL}users/sendotp`, {
        email: emailValue,
      });
      console.log("111111", res);
      if (res?.data?.success === true) {
        console.log("22222");
        toast.success(res?.data?.message);
        setIsOtpSent(true);
        startTimer();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to send OTP");
    }
  };
  const handleVerifyOtp = async (otpValue) => {
    try {
      const res = await axios.post(
        `${API_BASEURL.API_BASEURL}users/verifyotp`,
        {
          email,
          otp: otpValue,
        }
      );
      if (res?.data?.success === true) {
        toast.success(res?.data?.message);
        setIsOtpVerified(true);
        setOtp(["", "", "", ""]);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Invalid OTP");
    }
  };

  const handleOtpChange = (value, idx) => {
    let newOtp = [...otp];
    newOtp[idx] = value.replace(/[^0-9]/g, "");
    setOtp(newOtp);

    const otpValue = newOtp.join("");
    if (otpValue.length === 6 && newOtp.every((d) => d !== "")) {
      handleVerifyOtp(otpValue);
    }
  };

  return (
    <>
      <HeadingBack title={"User Add"} subHeading="" />
      <div className="p-20">
        <Form
          form={form}
          name="basic"
          layout={"vertical"}
          autoComplete="off"
          onFinish={handleSubmit}
        >
          <Row gutter={[24, 0]}>
            <Col lg={12}>
              <Form.Item
                label="Name"
                name="Name"
                rules={[
                  { required: true, message: "Name is required" },
                  { min: 4, message: "Min 4 character required" },
                  { max: 32, message: "Max 32 character allowed" },
                ]}
              >
                <Input
                  autoComplete="off"
                  className="form-control"
                  placeholder="Name"
                  onInput={onlyTextandSpaceFilter}
                />
              </Form.Item>
            </Col>
            <Col lg={12}>
              <Form.Item
                label="Mobile"
                name="Mobile"
                rules={[
                  { required: true, message: "Mobile is required" },
                  { validator: ValidatePhone },
                ]}
              >
                <Input
                  maxLength={10}
                  className="form-control"
                  placeholder="Mobile"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[24, 0]}>
            <Col lg={12}>
              <Form.Item
                label="Email ID"
                name="Email"
                rules={[
                  { required: true, message: "Email is required" },
                  { validator: ValidateEmail },
                ]}
              >
                <div>
                  <div className="flex">
                    <Input
                      style={{ width: "490px" }}
                      placeholder="Enter Email"
                    />
                    {/* <button
                      type="button"
                      onClick={handleSendOtp}
                      disabled={timer > 0}
                      style={{
                        backgroundColor: timer > 0 ? "#e5e5e597" : "#fecc4e",
                        color: timer > 0 ? "gray" : "black",
                        border: "none",
                        borderRadius: "5px",
                        marginLeft: "10px",
                        cursor: timer > 0 ? "not-allowed" : "pointer",
                        padding: "0 15px",
                      }}
                    >
                      {timer > 0
                        ? "OTP Sent"
                        : isOtpSent
                        ? "Resend OTP"
                        : "Send OTP"}
                    </button> */}
                  </div>

                  {/* {timer > 0 && (
                    <p style={{ marginTop: "5px", color: "gray" }}>
                      You can resend OTP in <b>{timer}s</b>
                    </p>
                  )} */}
                </div>
              </Form.Item>
            </Col>

            <Col lg={12}>
              {/* <Form.Item
                label="Verify OTP"
                name="Otp"
                rules={[{ required: true, message: "OTP is required" }]}
              >
                <div className="flex gap-2">
                  {[...Array(6)].map((_, idx) => (
                    <Input
                      key={idx}
                      maxLength={1}
                      value={otp[idx]}
                      onChange={(e) => {
                        const val = e.target.value.replace(/[^0-9]/g, "");
                        handleOtpChange(val, idx);

                        if (val.length === 1) {
                          setTimeout(() => {
                            const nextInput = document.querySelector(
                              `#otp-${idx + 1}`
                            );
                            if (nextInput) nextInput.focus();
                          }, 0);
                        }
                      }}
                      // disabled={isOtpVerified}
                      className="w-8 h-12 text-center border rounded-md mr-20"
                      style={{ width: "50px" }}
                      id={`otp-${idx}`}
                      onKeyDown={(e) => {
                        if (
                          e.key === "Backspace" &&
                          e.target.value.length === 0
                        ) {
                          const prevInput = document.querySelector(
                            `#otp-${idx - 1}`
                          );
                          if (prevInput) prevInput.focus();
                        }
                      }}
                    />
                  ))}
                </div>
              </Form.Item> */}
            </Col>
          </Row>

          {superAdmin && (
            <Row gutter={[24, 0]}>
              <Col lg={12}>
                <Form.Item
                  label="Organization"
                  name="OrganizationId"
                  rules={[{ required: true, message: "Organization is required" }]}
                >
                  <Select placeholder="Select Organization" showSearch optionFilterProp="children">
                    {organizations?.map((org) => (
                      <Option key={org.OrganizationId} value={org.OrganizationId}>
                        {org.Name} ({org.OrganizationId})
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )}

          <Row gutter={[24, 0]}>
            <Col lg={12}>
              <Form.Item
                label="Role"
                name="RoleId"
                rules={[{ required: true, message: "Role is required" }]}
              >
                <Select placeholder="Select Role">
                  <Option value={""}>Select Role</Option>
                  {(superAdmin ? rolesForOrganization(roleList, selectedOrganizationId) : roleList)?.map((item, idx) => (
                    <Option key={idx} value={item.RoleId}>
                      {item.Role}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col lg={12}>
              <Form.Item
                label="Password"
                name="Password"
                rules={PasswordRule()}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[24, 0]}>
            <Col lg={12}>
              <Form.Item label="Doctor Id (In case of Doctor)" name="DoctorId">
                <Input
                  placeholder="Doctor Id"
                  onInput={onlyAlphaNumericFilter}
                />
              </Form.Item>
            </Col>
            <Col lg={12}>
              <Form.Item label="Doctor Type" name="DoctorType">
                <Input
                  placeholder="Doctor Type"
                  onInput={onlyAlphaNumericFilter}
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="text-center">
            <LoadingButton type="submit" className="gradient-button w-auto" loading={submitting}>
              Submit
            </LoadingButton>
          </div>
        </Form>
      </div>
    </>
  );
};

export default AddUser;
